import React from 'react';
import { CButton } from '../../../UI';

import './style.scss';

export default React.forwardRef(({targetRef, setSlideOffset}, ref) => {
    if (!targetRef.current) {
        return null;
    }

    function handleScheduleSlide(isForvard = true) {
        if (!targetRef.current) return;

        if (isForvard) {
            setSlideOffset(targetRef.current.scrollLeft + targetRef.current.offsetWidth);
        } else {
            setSlideOffset(targetRef.current.scrollLeft - targetRef.current.offsetWidth);

        }
    }

    return (
        <div
            ref={ref}
            className="episodes-block-scrolling"
        >
            <CButton
                icon="play"
                round
                className="episodes-block-scrolling__button episodes-block-scrolling__button--prev"
                onClick={() => handleScheduleSlide(false)}
            />
            <CButton
                icon="play"
                round
                className="episodes-block-scrolling__button episodes-block-scrolling__button--next"
                onClick={() => handleScheduleSlide()}
            />
        </div>
    )
});
